module.exports = __webpack_public_path__ + "static/media/baxterstorey.e8942bd6.png";